import { File } from '../file';
import { ContentAccordionDownload } from './accordion-download';
import { ContentAdviceBox } from './advice-box';
import { ContentAudio } from './audio';
import { ContentAuthor } from './author';
import { ContentAvatar } from './avatar';
import { ContentButton } from './button';
import { ContentCategoryLinkList } from './category-link-list';
import { ContentCooperationInfobox } from './cooperation-infobox';
import { ContentFAQ } from './faq';
import { ContentImagesDecorative } from './images-decorative';
import { ContentImagesInformative } from './images-informative';
import { ContentInPageNavigationOpener } from './in-page-navigation-opener';
import { ContentInfo } from './info';
import { ContentIntro } from './intro';
import { ContentNumberCounter } from './number-counter';
import { ContentNumberDivider } from './number-divider';
import { ContentPortraitBox } from './portrait-box';
import { ContentProductLinkList } from './product-link-list';
import { ContentQuote } from './quote';
import { ContentSeaExitBox } from './sea-exit-box';
import { ContentArticleText } from './section';
import { ContentSimpleTable } from './simple-table';
import { ContentTopInfoBox } from './top-info-box';
import { ContentVideo } from './video';

/**
 * Model definition for Opener Landing Page
 */
export interface ContentOpenerLandingPage {
  __component: 'content.opener-landing-page';
  id: string;
  media?: File;
  layout?: 'sea';
  content?: (
    | ContentSeaExitBox
    | ContentButton
    | ContentAccordionDownload
    | ContentAdviceBox
    | ContentAudio
    | ContentVideo
    | ContentAvatar
    | ContentAuthor
    | ContentTopInfoBox
    | ContentCategoryLinkList
    | ContentCooperationInfobox
    | ContentFAQ
    | ContentImagesInformative
    | ContentImagesDecorative
    | ContentInPageNavigationOpener
    | ContentInfo
    | ContentIntro
    | ContentNumberCounter
    | ContentNumberDivider
    | ContentPortraitBox
    | ContentProductLinkList
    | ContentQuote
    | ContentArticleText
    | ContentSimpleTable
  )[];
}

export function isContentOpenerLandingPage(obj: { __component?: string }): obj is ContentOpenerLandingPage {
  return obj.__component === 'content.opener-landing-page';
}
